import { getStorage, setStorage } from '@/utils/storage'

const GUIDE_STORAGE_KEY = 'ftx_newbie_guide'

export const DEFAULT_GUIDE_CONFIG = {
  title: '新手指南',
  desc: '欢迎使用 FTX 贵金属交易平台，以下操作助您快速上手',
  tips: [
    '请先完成实名认证，否则无法进行出入金和交易',
    '入金地址仅支持 USDT-TRC20，请勿向该地址转入其他币种',
    '如需帮助，请随时点击右下角联系在线客服'
  ],
  deposit: [
    { step: 1, title: '复制入金地址', desc: '在"入金"页面复制平台提供的 USDT-TRC20 地址' },
    { step: 2, title: '转账至该地址', desc: '从您的钱包向该地址转入 USDT，最低金额 10 USDT' },
    { step: 3, title: '提交入金申请', desc: '转账完成后上传凭证并提交，审核通过后自动到账' }
  ],
  withdraw: [
    { step: 1, title: '选择出金方式', desc: '在"出金"页面选择 USDT 出金，填写收款地址和金额' },
    { step: 2, title: '确认出金信息', desc: '核对地址与金额无误后，输入交易密码确认' },
    { step: 3, title: '等待到账', desc: '审核通过后 USDT 将在 1-2 小时内到账' }
  ]
}

export function getGuideConfig() {
  return getStorage(GUIDE_STORAGE_KEY, DEFAULT_GUIDE_CONFIG)
}

export function saveGuideConfig(config) {
  setStorage(GUIDE_STORAGE_KEY, { ...DEFAULT_GUIDE_CONFIG, ...config })
}
